var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "generate-password-wrapper"
    },
    [
      _vm.$attrs["label"]
        ? _c("gg-input-label", [
            _vm._v(" " + _vm._s(_vm.$attrs["label"]) + " ")
          ])
        : _vm._e(),
      _c(
        "v-text-field",
        _vm._b(
          {
            staticClass: "compact-password",
            attrs: {
              type: _vm.inputType,
              label: "",
              loading: _vm.loading && _vm.showStrength,
              dense: ""
            },
            scopedSlots: _vm._u(
              [
                _vm.withGenerator
                  ? {
                      key: "append",
                      fn: function fn() {
                        return [
                          _vm.showAlertIcon
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    bottom: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function fn(_ref) {
                                          var on = _ref.on,
                                            attrs = _ref.attrs
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      color: _vm.strengthColor
                                                    }
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v(" mdi-alert-outline ")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    703752498
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v("Please, use a stronger password.")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-0 mr-1",
                              attrs: {
                                icon: "",
                                ripple: false
                              },
                              on: {
                                click: _vm.changeInputType
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: "#C2C2C2"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.appendIcon))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "generate-btn",
                              attrs: {
                                tile: "",
                                depressed: "",
                                elevation: "0",
                                color: "#ececec"
                              },
                              on: {
                                click: _vm.generatePassword
                              }
                            },
                            [_vm._v(" Generate ")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null,
                _vm.cpanelApp
                  ? {
                      key: "progress",
                      fn: function fn() {
                        return [
                          _vm.showStrength
                            ? _c("v-progress-linear", {
                                attrs: {
                                  value: _vm.currentStrength,
                                  color: _vm.strengthColor,
                                  absolute: "",
                                  height: "3"
                                }
                              })
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            ),
            model: {
              value: _vm.password,
              callback: function callback($$v) {
                _vm.password = $$v
              },
              expression: "password"
            }
          },
          "v-text-field",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }